<template>
  <div class="search-form">
    <div class="search-box-wrapper">
      <div class="search-item-wrapper">
        <p>{{ "โครงการ" }}</p>
        <el-select
          class="search-item"
          value-key="id"
          v-model="project"
          filterable
          clearable
          placeholder="เลือกโครงการ"
          :filter-method="handleFilterProject"
        >
          <el-option
            v-for="project in projectOptions"
            :key="project.id"
            :value="project"
            :label="project.label"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item-wrapper">
        <p>{{ "บ้าน" }}</p>
        <el-select
          class="search-item"
          value-key="id"
          v-model="home"
          filterable
          clearable
          :placeholder="isSelectedProject ? 'เลือกบ้าน' : 'กรุณาเลือกโครงการ'"
          :disabled="!isSelectedProject"
          :filter-method="handleFilterHome"
        >
          <el-option
            v-for="home in homeOptions"
            :key="home.id"
            :value="home"
            :label="home.label"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item-wrapper">
        <p>{{ "ชื่อลูกค้า" }}</p>
        <el-select
          class="search-item"
          value-key="id"
          v-model="user"
          filterable
          clearable
          remote
          :remote-method="searchUsers"
          :loading="loading"
          :placeholder="'ระบุชื่อลูกค้า'"
        >
          <el-option
            v-for="user in userResults"
            :key="user.id"
            :value="user"
            :label="user.label"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item-wrapper">
        <p>{{ "วันที่นัด" }}</p>
        <el-date-picker
          class="search-item"
          v-model="dateFrom"
          placeholder="เลือกวันที่นัด"
          format="dd MMMM yyyy"
          type="date"
        >
        </el-date-picker>
      </div>
      <div class="search-item-wrapper">
        <p>{{ "ถึง" }}</p>
        <el-date-picker
          class="search-item"
          v-model="dateTo"
          :placeholder="
            isSelectedDateFrom ? 'เลือกวันที่นัด' : 'กรุณาเลือกวันที่นัด'
          "
          :disabled="!isSelectedDateFrom"
          format="dd MMMM yyyy"
          type="date"
        >
        </el-date-picker>
      </div>
      <div class="search-item-wrapper" v-if="isReportPage">
        <p>{{ "สถานะงาน" }}</p>
        <el-select
          class="search-item"
          value-key="id"
          :placeholder="'เลือกสถานะ'"
          filterable
          clearable
          v-model="status"
        >
          <el-option
            v-for="status in statusOptions"
            :key="status.id"
            :value="status"
            :label="status.label"
        /></el-select>
      </div>
    </div>
    <div class="submit-button-wrapper">
      <button class="button reset-button ml-2" @click="handleResetSearch">
        <img src="/static/icons/supplier-close-icon.svg" />ยกเลิก
      </button>
      <button class="button search-button ml-2" @click="handleSearchSubmit">
        <img src="/static/icons/supplier-search-icon.svg" />ค้นหา
      </button>
    </div>
  </div>
</template>

<script>
import { Input, DatePicker, Select, Option } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { DateTime } from "luxon";
import { mSize } from "../StaticVariable";
import { jsonToString, stringToJson } from "../../lib/jsonFormatter";
import { navigationMenu } from "../../lib/mapper";

export default {
  props: ["projectResults"],
  components: {
    "el-input": Input,
    "el-date-picker": DatePicker,
    "el-select": Select,
    "el-option": Option,
    "sc-button": ScButton
  },
  data() {
    const statusOptions = [
      {
        id: "ALL",
        label: "ทั้งหมด"
      },
      {
        id: "CREATED",
        label: "รอยืนยัน"
      },
      {
        id: "CONFIRMED",
        label: "ยืนยันแล้ว/รอดำเนินการ"
      },
      {
        id: "PROVIDER_FULFILLED",
        label: "ปิดงานแล้ว"
      }
    ];

    return {
      windowWidth: window.innerWidth,
      previousPath: null,
      dateFrom: null,
      dateTo: null,
      user: this.$route.query.user || null,
      userResults: [],
      project: null,
      projectQuery: "",
      home: null,
      homeResults: [],
      homeQuery: "",
      loading: false,
      statusOptions: statusOptions,
      status: statusOptions[0]
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupQuery();
    },
    setupQuery() {
      const { dateTime, project, home, status, user } = this.$route.query;

      if (dateTime) {
        const dateTimeJSON = stringToJson(dateTime);

        this.dateFrom = DateTime.fromISO(dateTimeJSON.from).toJSDate();

        if (dateTimeJSON.hasDateTo) {
          this.dateTo = DateTime.fromISO(dateTimeJSON.to).toJSDate();
        }
      }

      if (project) {
        this.project = stringToJson(project);
      }

      if (home) {
        this.home = stringToJson(home);
      }

      if (this.isNotAllStatus(status)) {
        this.status = stringToJson(status);
      } else {
        this.status = undefined;
      }

      if (user) {
        const userJSON = stringToJson(user);

        this.user = userJSON;
        this.userResults = [userJSON];
      }
    },
    checkRoutePath() {
      if (
        this.previousPath === null ||
        this.$route.path !== this.previousPath
      ) {
        this.previousPath = this.$route.path;
      }

      if (Object.keys(this.$route.query).length > 0) {
        return;
      }

      this.clearSearch();
    },
    handleFilterProject(query) {
      this.projectQuery = query;
    },
    async setupHomes(projectId) {
      const homes = await this.fetchHomes(projectId);

      this.homeResults = homes.map(home => {
        return {
          id: home.homeId,
          label: home.addressNo
        };
      });
    },
    async fetchHomes(projectId) {
      const response = await baanRueJaiClient.others.supplier.getHomes(
        projectId
      );

      return response;
    },
    handleFilterHome(query) {
      this.homeQuery = query;
    },
    async searchUsers(query) {
      this.loading = true;

      const [firstName, lastName, ...rest] = query.split(" ");
      const params = {
        firstName: firstName.trim(),
        lastName: lastName
          ? (lastName + " " + rest.join(" ")).trim()
          : undefined
      };

      const result = await this.fetchUser(params);

      this.userResults = result.users.map(item => {
        const user = item.user ? item.user : item;

        return {
          id: user.user_id,
          label: `${user.user_profile.first_name} ${user.user_profile.last_name}`
        };
      });

      this.loading = false;
    },
    async fetchUser(query) {
      const response = await baanRueJaiClient.others.supplier.getUsers(query);

      return response;
    },
    handleSearchSubmit() {
      let dateTime;
      const from = DateTime.fromJSDate(this.dateFrom).toISO();
      if (this.dateFrom) {
        const to = DateTime.fromJSDate(this.dateTo || this.dateFrom)
          .endOf("day")
          .toISO();
        const hasDateTo = this.dateTo !== null;

        dateTime = {
          from: from,
          to: to,
          hasDateTo
        };
      }

      const query = {
        dateTime: dateTime ? jsonToString(dateTime) : undefined,
        project: this.project ? jsonToString(this.project) : undefined,
        home: this.home ? jsonToString(this.home) : undefined,
        status: this.isNotAllStatus(this.status)
          ? jsonToString(this.status)
          : undefined,
        user: this.user ? jsonToString(this.user) : undefined
      };

      this.$emit("searchSubmit", query);
    },
    clearSearch() {
      this.dateFrom = null;
      this.dateTo = null;
      this.project = null;
      this.home = null;
      this.status = this.statusOptions[0];
      this.user = null;
      this.userResults = [];
    },
    handleResetSearch() {
      this.clearSearch();

      this.$emit("searchSubmit", "");
    },
    isNotAllStatus(status) {
      return status && status.id !== "ALL";
    }
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= mSize;
    },
    navigationMenu() {
      return this.$route.params.navigationMenu;
    },
    isReportPage() {
      return this.navigationMenu === navigationMenu.REPORT;
    },
    projectOptions() {
      if (!this.projectQuery) {
        return this.projectResults;
      }

      return this.projectResults.filter(project => {
        return project.label.includes(this.projectQuery);
      });
    },
    isSelectedProject() {
      return this.project;
    },
    isSelectedDateFrom() {
      return this.dateFrom;
    },
    homeOptions() {
      if (!this.homeQuery) {
        return this.homeResults;
      }

      return this.homeResults.filter(home => {
        return home.label.includes(this.homeQuery);
      });
    }
  },
  watch: {
    async "$route.query"() {
      this.checkRoutePath();
    },
    async project(newVal, oldVal) {
      if (!newVal) {
        this.projectQuery = null;
        this.home = null;
        return;
      }

      if (!oldVal && newVal === oldVal) {
        return;
      }

      if (oldVal && newVal) {
        this.home = null;
      }
      this.setupHomes(newVal.id);
    },
    async home(value) {
      if (!value) {
        this.homeQuery = null;
        return;
      }
    },
    async user(value) {
      if (!value) {
        this.userResults = [];
        return;
      }
    },
    async status(value) {
      if (!value) {
        this.status = this.statusOptions[0];
        return;
      }
    },
    async dateFrom(value) {
      if (!value) {
        this.dateTo = null;
        return;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.search-form {
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: auto;
}

.search-box-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 16px;
  padding: 24px;
}

.search-item-wrapper {
  display: flex;
  flex-direction: column;

  p {
    font-size: $font-14;
  }
}

.search-item {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.submit-button-wrapper {
  margin-inline: 24px;
  margin-bottom: 24px;
  text-align: right;

  .button {
    padding-inline: 12px;
    height: 40px;
    font-weight: bold;
    font-size: $font-16;
    border-radius: 8px;
    align-items: center;

    img {
      margin-right: 8px;
    }
  }

  .search-button {
    background: transparent;
    border: 1px solid $supplier-primary-color;
    color: $supplier-primary-color;

    &:hover:not(:disabled) {
      background: $color-light-gray-1-hover;
    }
  }

  .reset-button {
    color: $black;
    background: transparent;
    border: 1px solid $color-light-gray-1;

    &:hover:not(:disabled) {
      background: $color-light-gray-1-hover;
    }
  }
}

@media (max-width: ($m-size - 1)) {
  .search-box-wrapper {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 16px;
    padding: 16px;
  }

  .submit-button-wrapper {
    display: flex;
    flex-direction: row;
    margin-inline: 16px;
    margin-block: 16px;

    .button {
      width: 50%;
      padding-inline: 16px;
    }
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .search-box-wrapper {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-gap: 16px;
    padding: 24px;
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .search-box-wrapper {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-gap: 16px;
    padding: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/components/SearchForm.vue